module.exports = __webpack_public_path__ + "img/profile.c2ef36d3.svg";